<template>
  <div>
    <h1>Importazioni</h1>
    <h2 v-if="modelli.length === 0" class="red--text"><br/><br/><br/>Attualmente non sono definite procedure di importazione dati</h2>
    <v-row class="mt-5" v-if="modelli.length > 0"> 
      <v-col cols="3" v-for="(m, idx) in modelli" :key="idx">
        <v-card>
          <v-card-title>
            <span class="text-h5">{{ m.titolo }}</span>
          </v-card-title>
          <v-card-subtitle>
            {{ m.descrizione }}
          </v-card-subtitle>
          <div class="mx-4 text-subtitle-3">Tipo importazione: {{ m.file.tipo }}</div>
          <div class="mx-4 text-subtitle-3">Sorgente: {{ m.file.sorgente || 'locale' }}</div>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="onImporta(m.codice, idx, true)">Importa</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>

  </div>
</template>

<script>
  import _ from 'lodash'
  import { verificaLicenza } from '@/mixins/verificaLicenza.js'
  import configurazioni from '@/services/configurazioniService.js'
  import importService from '@/services/importService.js'

  export default {
    mixins: [verificaLicenza],
    data: (vm) => ({
      modelli: [],
      startFormatted: [],
      endFormatted: [],
      filtro: [],
      menuStart: [],
      menuEnd: []    
    }),   
    async mounted() {      
      await this.verificaModuliLocali()
      const modelli = await configurazioni.getConfigurazione('import_dati', 'modelli')
      this.modelli = modelli.automatici || []
    },
    methods: {
      async onImporta(codiceModello, idx, verbose) {
        const modello = this.modelli.find(x => x.codice === codiceModello)
        const filtro = this.filtro[idx]
        try {
          const importazione = await importService.leggeFile(modello.file.nomeFile, modello)
          const dati = importazione.dati
          const importazioneProdotti = await importService.leggeFile(modello.file.nomeFileProdotti, modello)
          const arrProdotti = _.uniq(importazioneProdotti.dati)
          const datiProdotti = arrProdotti.map(x => x.split(';'))           

          if (dati.length > 0) {
            const result = await importService.generaMovimenti(modello, dati, datiProdotti)
            if (verbose && result) {
              alert(result.status)
            }
          }
          if (modello.eliminaFile) {
            await importService.eliminaFile(importazione.file, modello)
            await importService.eliminaFile(importazioneProdotti.file, modello)
          }
        } catch(error) {
          console.log(error)
        }
      }
    }
  }
</script>
